import { MockCard, MockSearchInput, MockSelect } from '../../components/mockups/MockUI'
import { MockAgGridHeader } from '../../components/mockups/MockTable'

export function TableOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Обзор таблицы
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Таблица» — сводная Excel-подобная таблица всех позиций из всех заявок. Позволяет
          работать как в привычной таблице: выделять диапазоны, копировать в буфер, редактировать
          ячейки.
        </p>
      </div>
      <MockAgGridHeader
        columns={[
          'Код',
          'Заявка',
          'Партномер',
          'Бренд',
          'Матрица',
          'Кол-во',
          'Статус',
          'Приоритет',
          'Кат.',
          'Дедлайн',
          'Закупщик 1',
          'Закупщик 2',
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Ключевые возможности:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Excel-подобное выделение диапазона (зажать мышь и протянуть)</li>
            <li>Копирование в буфер (Ctrl+C) в формате TSV (вставляется в Excel)</li>
            <li>Редактирование ячеек кликом (партномер, бренд, заметки)</li>
            <li>Группировка строк по заявкам (визуальные разделители)</li>
            <li>Закрепление колонок слева (кнопка «Закрепить столбцы»)</li>
            <li>Три режима высоты строк: компактный, стандартный, высокий</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function TableFilters() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Фильтры и поиск
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Панель фильтров расположена над таблицей. Фильтрация серверная — при изменении фильтра
          данные перезагружаются с сервера.
        </p>
      </div>
      <MockCard>
        <div className="flex items-center gap-2 flex-wrap">
          <MockSearchInput placeholder="Поиск по партномеру, бренду..." />
          <MockSelect label="" value="Все статусы" />
          <MockSelect label="" value="Все категории" />
          <MockSelect label="" value="Все приоритеты" />
          <MockSelect label="" value="Лимит: 500" />
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Детали:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Поиск</span> — с задержкой 400мс, ищет по партномеру и
              бренду
            </li>
            <li>
              <span className="font-medium">Лимит</span> — сколько строк загружать (500 по
              умолчанию, можно до 5000)
            </li>
            <li>
              <span className="font-medium">Кнопка «Сброс»</span> — очистить все фильтры
            </li>
            <li>Строка «Показано 500 / 12345» — сколько загружено из общего количества</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function TableGroups() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Группировка</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Позиции автоматически группируются по заявкам. Строки одной заявки визуально объединены
          разделителями — первая и последняя строки группы выделяются.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          Столбец «Код» и «Заявка» показывают к какому клиенту и заявке относится позиция.
          Сортировка по умолчанию — по дате создания заявки, позиции внутри — по приоритету.
        </div>
      </MockCard>
    </div>
  )
}

export function TableColumns() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Настройка колонок
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Колонки можно перетаскивать, менять ширину и закреплять. Настройки сохраняются в браузере
          для каждого пользователя.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Управление колонками:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Перетаскивание</span> — зажмите заголовок колонки и
              перетащите
            </li>
            <li>
              <span className="font-medium">Ширина</span> — потяните за край заголовка
            </li>
            <li>
              <span className="font-medium">Закрепление</span> — кнопка «Закрепить столбцы» →
              чекбоксы
            </li>
            <li>
              <span className="font-medium">Сброс</span> — кнопка «Сброс» восстанавливает настройки
              по умолчанию
            </li>
          </ul>
          <p className="mt-2">
            Динамические колонки закупщиков: для каждого закупщика в системе автоматически создаётся
            персональная колонка для заметок.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function SettingsAccount() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Настройки аккаунта
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Настройки» доступна через иконку шестерёнки в нижней части сайдбара. Позволяет
          сменить пароль и настроить личные данные.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Доступные настройки:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Смена пароля (текущий + новый + подтверждение)</li>
            <li>Имя пользователя (отображается в сайдбаре и комментариях)</li>
            <li>Персональный email (для уведомлений, если настроены)</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}
